// AP Statistics - Main data file combining all units
import { unit1, unit2, unit3 } from './data-part1';
import { unit4, unit5, unit6 } from './data-part2';
import { unit7, unit8, unit9 } from './data-part3';

export const apStatsData = {
  units: [unit1, unit2, unit3, unit4, unit5, unit6, unit7, unit8, unit9]
};